import { CampaignBlocks, } from "@kvix/shared";
import React, { useEffect, useState } from "react";
import { Text } from "../../Primitives";
import { AdminFormFilePicker, AdminFormInput } from "../admin";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
    gridItem: {
        display: "flex",
        flexDirection: "row",
    },
    featureIcon: {
        maxHeigth: "120px",
        maxWidth: "120px",
        marginRight: "10px",
        [theme.breakpoints.down("sm")]: {
            maxHeigth: "105px",
            maxWidth: "105px",
        },
    },
    featureTitle: {
        [theme.breakpoints.down("sm")]: {
            fontSize: "28px",
            lineHeight: 1,
        },
    },
    featureText: {
        [theme.breakpoints.down("sm")]: {
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 500,
            marginTop: 10,
        },
    },
}));
export class FeatureBlock {
    constructor() {
        this.defaultStructure = {
            name: CampaignBlocks.FeatureBlock,
            titles: [""],
            texts: [""],
            media: { images: [""] },
        };
        this.Render = (props) => {
            const { block } = props;
            const classes = useStyles();
            return (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("img", { src: block.media.images[0], className: classes.featureIcon })),
                React.createElement("div", null,
                    React.createElement(Text, { className: classes.featureTitle, variant: "h2" }, block.titles[0]),
                    React.createElement(Text, { className: classes.featureText, variant: "body1" }, block.texts[0]))));
        };
        this.Compose = (props) => {
            const { block, composeAction, index } = props;
            const [texts, setTexts] = useState(block.texts);
            const [titles, setTitles] = useState(block.titles);
            const [images, setImages] = useState(block.media.images);
            useEffect(() => {
                const temp = Object.assign(Object.assign({}, block), { texts, titles, media: { images } });
                composeAction(temp, index);
            }, [texts, titles, images]);
            const titleOnChange = (event) => {
                setTitles([event.target.value]);
            };
            const textOnChange = (event) => {
                //Max 100 characters check
                if (event.target.value.length > 100) {
                    return;
                }
                setTexts([event.target.value]);
            };
            const filePicker = (file) => {
                setImages([file]);
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(AdminFormInput, { name: "title", label: "Title", onChange: titleOnChange, required: true, value: titles[0] }),
                React.createElement(AdminFormInput, { name: "text", label: "Text (max 100 characters)", onChange: textOnChange, required: true, value: texts[0] }),
                React.createElement(AdminFormFilePicker, { name: "image", acceptedFileTypes: ["image/*"], label: "Image", folder: "campaign", onChange: filePicker, required: true, file: images[0] })));
        };
    }
}
//# sourceMappingURL=FeatureBlock.js.map